import React, { Component } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import VirtualDebitCardDetails from "./virtualDebitCardDetails";
import NewVirtualDebitCardButton from "./newVirtualDebitCardButton";
import GenericModal from "../../buttons/genericModal";
import { Tooltip } from "antd";

class VirtualDebitCardView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountStatus: this.props.bankAccountInfo ? this.props.bankAccountInfo.status : undefined,
            'visible': false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.bankAccountInfo !== this.props.bankAccountInfo) {
            this.setState({
                accountStatus: this.props.bankAccountInfo ? this.props.bankAccountInfo.status : undefined,
            });
        }
    }

    render() {
        const userPermission = localStorage.getItem("arpariUserPermission");
        return (
            <>
                {(this.state.accountStatus !== "Closed" && this.state.accountStatus !== undefined && this.props.cardInfo.virtual_debit_card_enabled
                ) &&
                (this.props.cardInfo.virtual_debit_card_available ?
                    <GenericModal
                        visible={this.state.visible}
                        handleCancelModal={() => {
                           this.setState((prevState) => ({
                            ...prevState,
                            visible: false,
                           }));
                       }}
                        showModal={() => {
                            if (userPermission === "RO") {
                               return;
                            }
                            this.setState((prevState) => ({
                                ...prevState,
                                visible: true,
                            }));
                        }}
                        size="md"
                        button={
                            <Tooltip title={userPermission === "RO" ? "Not permitted. Please check permission with your admin." : undefined}>
                            <span
                                disabled={userPermission === "RO"}
                                style={userPermission === "RO" ? { cursor: "not-allowed" } : { fontWeight: "400", fontSize: "14px" }}>
                                Virtual Debit Card <ArrowRightOutlined />
                            </span>
                        </Tooltip> 
                        }
                        modalTitle="Virtual debit card details"
                        modalBody={
                            <>
                                <VirtualDebitCardDetails
                                    cardDetails={this.props.cardInfo.virtual_debit_card_details}
                                    bankAccountId={this.props.bankAccountId}
                                />
                            </>
                        }
                    />
                    :
                    <NewVirtualDebitCardButton
                        bankAccountId={this.props.bankAccountId}
                        showVirtualDebitCard={this.props.showVirtualDebitCard}
                    />
                )
                }


            </>
        );
    }
}

export default VirtualDebitCardView;
